// src/services/pdf/pdfConfig.js
// Company data, formatting helpers, and document config for PDF generation.

// =========================
// Company Data (update when company is formally registered)
// =========================
export const COMPANY = Object.freeze({
    name: "LOS TOLDOS ENTERTAINMENT S.L.",
    shortName: "Los Toldos",
    cif: "B-XXXXXXXX",
    address: "Getxo, Bizkaia",
    phone: "+34 XXX XXX XXX",
    email: "info@wearelostoldos.com",
    web: "www.wearelostoldos.com",
    iban: "ES00 0000 0000 0000 0000 0000",
});

// =========================
// Representacion legal y banco
// =========================
// Datos fijos de la mercantil que no viven en team_settings: quien comparece
// y firma en nombre de la sociedad, y la entidad del IBAN. Se citan
// literalmente en el contrato (apartado COMPARECEN y forma de pago).
export const LEGAL_REP = Object.freeze({
    name: "Guillermo Barcala Migoya",
    nif: "78943007S",
});

export const BANK_NAME = "Caja Rural de Navarra";

// Canal de contacto ordinario fijado en el contrato.
export const CONTRACT_EMAIL = "hola@wearelostoldos.com";

// =========================
// Tax & Financial Config
// =========================
export const IVA_RATE = 0.21; // 21% IVA general

// =========================
// Brand Colors (RGB arrays for jsPDF)
// =========================
export const COLORS = Object.freeze({
    PRIMARY: [247, 116, 239], // #f774ef — rosa Los Toldos
    DARK: [158, 17, 71],   // #9e1147 — granate oscuro
    BLACK: [20, 20, 20],
    TEXT: [50, 50, 50],
    TEXT_LIGHT: [120, 120, 120],
    GRAY: [200, 200, 200],
    LIGHT_BG: [248, 248, 248],
    WHITE: [255, 255, 255],
    ACCENT: [99, 102, 241],  // indigo for accents
    SUCCESS: [16, 185, 129],
    WARNING: [245, 158, 11],
});

// =========================
// Formatting Helpers
// =========================
export function formatCurrency(n) {
    const x = Number(n);
    if (!Number.isFinite(x)) return "—";
    return new Intl.NumberFormat("es-ES", {
        style: "currency",
        currency: "EUR",
    }).format(x);
}

// Importe sin simbolo de moneda: el contrato escribe la cifra seguida
// de la palabra "EUROS" en lugar del simbolo.
export function formatAmount(n) {
    const x = Number(n);
    if (!Number.isFinite(x)) return "—";
    return new Intl.NumberFormat("es-ES", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
        // es-ES omite el separador de millares en cifras de 4 digitos, asi que
        // por defecto un mismo importe se escribe "8500,00" y su total
        // "10.285,00". En un contrato esa mezcla queda como una errata.
        useGrouping: "always",
    }).format(x);
}

export function formatDate(iso) {
    if (!iso) return "—";
    try {
        return new Date(iso).toLocaleDateString("es-ES", {
            day: "numeric",
            month: "long",
            year: "numeric",
        });
    } catch {
        return iso;
    }
}

export function formatDateShort(iso) {
    if (!iso) return "—";
    try {
        return new Date(iso).toLocaleDateString("es-ES", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
        });
    } catch {
        return iso;
    }
}

export function todayFormatted() {
    return formatDate(new Date().toISOString());
}

export function todayShort() {
    return formatDateShort(new Date().toISOString());
}

// =========================
// Document Number Generator
// =========================
let _seqCounter = {};

export function generateDocNumber(prefix = "DOC") {
    const year = new Date().getFullYear();
    const key = `${prefix}-${year}`;
    if (!_seqCounter[key]) {
        _seqCounter[key] = Math.floor(Math.random() * 900) + 100; // temp random seed
    }
    _seqCounter[key]++;
    const seq = String(_seqCounter[key]).padStart(4, "0");
    return `${prefix}-${year}-${seq}`;
}

// =========================
// Safe file name helper
// =========================
export function safeFileName(name) {
    return (name || "documento").replace(/[^a-zA-Z0-9_.-]/g, "_");
}
